import { render } from "./EventsCalendarItem.vue?vue&type=template&id=cf774280&scoped=true&ts=true"
import script from "./EventsCalendarItem.vue?vue&type=script&lang=ts"
export * from "./EventsCalendarItem.vue?vue&type=script&lang=ts"

import "./EventsCalendarItem.vue?vue&type=style&index=0&id=cf774280&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf774280"]])

export default __exports__